import React from 'react';
import { Link } from 'react-router-dom';

function ReachMe() {
  return (
    <section className='bg-black pt-20 pb-20 md:pr-20 md:pb-20 sm:w-12/12 md:12/12  lg:w-full'>
      <div className='bg-grey-default h-80 block p-12 mx-auto px-4 sm:w-12/12  md:w-12/12 md:ml-20 lg:w-11/12 sm:ml-16 sm:h-full lg:justify-center'>
        <div className="contact">
          <h1 className='text-white font-bold text-2xl md:text-3xl xl:text-3xl'>
            Let’s work together on your next projects
          </h1>
        </div>
        <div className="subtitle mt-4 md:flex md:items-center md:justify-between">
          <p className='text-white'>
          I'm open to inquiries, collaborations, and friendly conversations. Your input is valuable, so don't hesitate to reach out. Let's connect and explore opportunities together!

          </p>
          <button className='bg-orange-default text-white p-2 m-4 font-bold rounded ease-linear transform hover:scale-110 transition duration-500'>
            <Link to='/contact'>Contact</Link>
          </button>
        </div>
      </div>
    </section>
  );
}

export default ReachMe;
